import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["loading", "dropdown", "label", "menu", "radio"]

  connect() {
    this.fetchCalendars();
  }

  fetchCalendars() {
    var controller = this;
    var url = this.element.dataset.googleCalendarSingleSelectUrl;

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (data) {
        controller.buildDropdown(data.calendars);
        controller.loadingTarget.classList.add("d-none");
        controller.dropdownTarget.classList.remove("d-none");

        var dirtyFormEl = controller.element.closest("[data-controller*='google-dirty-form']");
        if (dirtyFormEl) {
          var dirtyForm = controller.application.getControllerForElementAndIdentifier(dirtyFormEl, "google-dirty-form");
          if (dirtyForm) dirtyForm.resetInitialState();
        }
      },
      error: function () {
        controller.loadingTarget.innerHTML = '<span class="text-danger">Unable to load calendars.</span>';
      },
    });
  }

  buildDropdown(calendars) {
    var selectedId = this.element.dataset.googleCalendarSingleSelectSelectedId;
    var connectionId = this.element.dataset.googleCalendarSingleSelectConnectionId;
    var $menu = $(this.menuTarget);
    var selectedName = "Primary Calendar";

    calendars.forEach(function (cal) {
      var name = cal[0];
      var calId = cal[1];
      var radioId = "cal-" + connectionId + "-" + calId.replace(/[^a-zA-Z0-9-]/g, "-");
      var isSelected = calId === selectedId;

      if (isSelected) selectedName = name;

      var $input = $('<input type="radio" class="d-none" />')
        .attr("name", "google_connection[calendar_id]")
        .attr("value", calId)
        .attr("id", radioId)
        .attr("data-target", "google-calendar-single-select.radio")
        .attr("data-action", "change->google-calendar-single-select#changed")
        .prop("checked", isSelected);
      var $label = $('<label class="dropdown-item"></label>')
        .attr("for", radioId)
        .toggleClass("active", isSelected)
        .text(name);

      $menu.append($input).append($label);
    });

    this.labelTarget.textContent = selectedName;
  }

  changed() {
    this.radioTargets.forEach((r) => {
      const label = this.element.querySelector(`label[for="${r.id}"]`);
      if (label) label.classList.toggle("active", r.checked);
    });

    const selected = this.radioTargets.find((r) => r.checked);
    if (selected) {
      const label = this.element.querySelector(`label[for="${selected.id}"]`);
      this.labelTarget.textContent = label
        ? label.textContent.trim()
        : selected.value;
    }
  }
}
